<template>
  <div class="feedback-content">
    <span class="feedback-content__title">Can you tell us more about your question?</span>

    <div class="checkbox-options" v-for="option in CheckboxOptions">
      <Button
        color="green"
        full
        invert
        class="btn-spaced-between"
        :key="option.value"
        @click="handleSelection(option.value)"
      >
        {{ option.label }}
        <SquareCheck :checked="selections.includes(option.value)" :value="option.value" />
      </Button>
    </div>
    <Button color="red" @click="handleMessageQuestions" :disabled="loading || selections.length === 0">Continue</Button>
    <span class="feedback-content__cancel" @click="emits('go-to-stage', Stages.DEFAULT)">Back</span>
  </div>
</template>

<script setup lang="ts">
import { SelectionForStage, Selections, Stages } from './types'
import { ref } from 'vue'
import Button from '@/components/Theme2/Button.vue'
import { SquareCheck } from '@/components/Theme'
import { redirectTo } from 'app/javascript/src/utils/functions'
import { useTypedItineraryStore } from 'app/javascript/src/stores/typed'
import { Product } from 'app/javascript/src/models'
import { useAuthUserState } from 'app/javascript/src/stores'
import api from 'app/javascript/src/utils/api'
import { useShared } from 'app/javascript/src/helpers/vueHelpers'
import { logErrorOnSentry } from 'app/javascript/src/utils/errorReportingUtils'

const CheckboxOptions: { label: string; value: SelectionForStage<Stages.HAVE_QUESTIONS> }[] = [
  {
    label: 'Details of the trip',
    value: Selections.DETAILS_OF_TRIP,
  },
  {
    label: 'Details of the contract, policies, etc.',
    value: Selections.DETAILS_OF_CONTRACT,
  },
  {
    label: 'Traveler experience',
    value: Selections.TRAVELER_EXPERIENCES,
  },
  {
    label: 'How the process works',
    value: Selections.HOW_PROCESS_WORKS,
  },
  {
    label: 'Something else',
    value: Selections.ASK_SOMETHING_ELSE,
  },
]

const emits = defineEmits<{
  (e: 'go-to-stage', stage: Stages): void
}>()

const itineraryStore = useTypedItineraryStore<Product>()
const userAuth = useAuthUserState()
const { componentInfo } = useShared()

const loading = ref(false)
const selections = ref<SelectionForStage<Stages.HAVE_QUESTIONS>[]>([])
const handleSelection = (selection: SelectionForStage<Stages.HAVE_QUESTIONS>) => {
  if (selections.value.includes(selection)) {
    selections.value = selections.value.filter(s => s !== selection)
  } else {
    selections.value.push(selection)
  }
}

const handleMessageQuestions = async () => {
  if (selections.value.length === 0 || !itineraryStore.data || loading.value) {
    return
  }

  try {
    loading.value = true
    await api.post(`/api/chatrooms/${itineraryStore.chatroomId}/messages/self_serve_message`, {
      selections: selections.value,
      sender_name: userAuth.name.value,
    })

    redirectTo(`/travelers/messages?itineraryRequestId=${itineraryStore.data.itineraryRequestId}`)
  } catch (error) {
    logErrorOnSentry(error, componentInfo)
    loading.value = false
  }
}
</script>

<style lang="scss" scoped>
.checkbox-options {
  width: 100%;
}

.btn-spaced-between {
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: $spacing-2;
}
</style>
